var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRupRnd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_640_7937)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.49999 0.811279C4.19343 0.811279 0.702209 4.3026 0.702209 8.60916C0.702209 12.9156 4.19343 16.4073 8.49994 16.4073C12.8064 16.4073 16.298 12.9157 16.298 8.60916C16.2979 4.3026 12.8066 0.811279 8.49999 0.811279ZM11.7818 10.9643C11.7818 11.1173 11.6072 11.2465 11.4007 11.2465H4.62824C4.4217 11.2465 4.24718 11.1173 4.24718 10.9643V7.67383C4.24718 7.52094 4.42164 7.39165 4.62824 7.39165H11.4007C11.6071 7.39165 11.7818 7.52094 11.7818 7.67383L11.7818 10.9643ZM13.1301 9.61566C13.1301 9.76871 12.9554 9.898 12.749 9.898H12.5907V7.67378C12.5907 7.07215 12.0569 6.5826 11.4007 6.5826H5.59554V6.32532C5.59554 6.17243 5.77 6.04314 5.97659 6.04314H12.7491C12.9555 6.04314 13.1301 6.17243 13.1301 6.32532V9.61566Z",
    fill: "#FDC648"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.2713 10.2349L7.27147 9.45443V9.20056H7.81997C7.93071 9.20056 8.01952 9.17653 8.08638 9.12847C8.15534 9.08041 8.19921 9.01041 8.21802 8.91847H7.27147V8.6834H8.21802C8.19921 8.59146 8.15534 8.52251 8.08638 8.47654C8.01952 8.42848 7.93071 8.40445 7.81997 8.40445L7.27147 8.40132V8.16625H8.80099V8.40759L8.30265 8.40445C8.3507 8.42326 8.3904 8.45773 8.42175 8.50788C8.45518 8.55803 8.47816 8.61654 8.4907 8.6834H8.80099V8.91847H8.49384C8.4813 9.01459 8.44682 9.10026 8.3904 9.17548C8.33608 9.2507 8.26503 9.31025 8.17727 9.35413C8.08952 9.39801 7.98713 9.421 7.87012 9.42309H7.66326L8.73517 10.2349H8.2713Z",
    fill: "#FDC648"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_640_7937"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15.596,
    height: 15.596,
    fill: "white",
    transform: "translate(0.702087 0.811279)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRupRnd);
export default __webpack_public_path__ + "static/media/rup_rnd.1bb4d3380c4f464e6ae6a51a179114e1.svg";
export { ForwardRef as ReactComponent };